module.exports = __webpack_public_path__ + "static/media/label.58be9cb6.png";